import { DealCard } from "components/DealCard.component"
import { Box } from "components/Layout.component"
import { Text } from "components/Typography.component"
import { Button } from "components/legacy/Button.component"
import { H3 } from "components/legacy/typography"
import formatDistanceToNowStrict from "date-fns/formatDistanceToNowStrict"
import { isoToHuman, isFuture } from "helpers/dates"
import React from "react"
import styled from "styled-components"

import { selectDealLinks } from "../selectors"
import { IBackendDealInfo } from "../types"

import { RaiseInfo } from "./RaiseInfo.component"
import { TokenPrice } from "./TokenPrice.component"

const Footer = styled.div`
  margin-top: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 80px;
  flex-direction: column;
`

const WhitelistLink = styled.a`
  width: 100%;
`

const DealContent = styled(Box)``

interface IUpcomingDealProps {
  deal: IBackendDealInfo
}

export const UpcomingDeal: React.FC<IUpcomingDealProps> = ({ deal }) => {
  const links = selectDealLinks(deal)

  return (
    <DealCard
      logoUrl={deal.logoUrl}
      chain={deal.chain}
      about={deal.about}
      isIdo={deal.isIdo}
      links={links}
      headerComponent={
        <RaiseInfo name={deal.name} dealSizeWei={deal.dealSize} raisedWei={deal.totalRaised} />
      }
      footerComponent={
        <DealContent px={{ _: 0, tablet: 5 }}>
          <Box mt={5}>
            <TokenPrice
              vestingSchedule={deal.vestingSchedule}
              weightedAveragePrice={deal.weightedAveragePrice}
            />
          </Box>

          {!deal.started && deal.desiredStartTime && isFuture(deal.desiredStartTime) && (
            <Box mt={1}>
              <H3>START DATE</H3>
              <Text opacity={0.7} as="span">
                {isoToHuman(deal.desiredStartTime)}
              </Text>
              <Text variant="bold" shade="gold" as="span" style={{ marginLeft: 8 }}>
                {formatDistanceToNowStrict(new Date(deal.desiredStartTime))} from now
              </Text>
            </Box>
          )}

          <Footer>
            <WhitelistLink href={deal.discordInviteUrl} target="_blank" rel="noreferrer">
              <Button size="lg" color="gold" fullWidth>
                Deal Information
              </Button>
            </WhitelistLink>
          </Footer>
        </DealContent>
      }
    />
  )
}
